<template>
</template>

<script>
export default {
    name: 'Blog',
    data() {
        return {
            
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Blog.vue